

import React, { memo, useState } from 'react';
import ToggleValueAddon from '../../components/ToggleValueAddon';
import { getCostRange } from '../../../../utils';












const DEFAULT_COST = '0';

function SingleVoiceArtist({
  voiceOverArtist,
  onChangeAddon,
  disabled,
  VOICE_OVER_ARTIST,
  onInfoClick,
  editingMode,
  showAboutInfo
}) {
  const [selected, setSelected] = useState(Boolean(voiceOverArtist));
  const subtitle = `Professional voice. ${
  editingMode ? 'Enter billed amount in USD.' : 'Allow up to 48 hours.'
  } `;

  const optionWithCost = VOICE_OVER_ARTIST.find(({ value }) => value);
  const cost = optionWithCost ? optionWithCost.cost : DEFAULT_COST;
  const { maxCost, currencySymbol } = getCostRange(VOICE_OVER_ARTIST);

  const handleChange = () => {
    const newSelected = !selected;
    setSelected(newSelected);

    if (newSelected) {
      const createdAt = new Date().toISOString();
      const newValue = { value: true, cost, createdAt };

      return void onChangeAddon(newValue);
    }

    onChangeAddon(null);
  };

  return (
    <div className="single-voice-artist-addon">
      <ToggleValueAddon
        id="single-voice-artist"
        title="Voice Over Artist"
        subtitle={subtitle}
        icon="voiceover"
        costString={`From ${currencySymbol}${maxCost}`}
        selected={selected}
        onChange={handleChange}
        withInfo={showAboutInfo}
        onInfoClick={onInfoClick}
        disabled={disabled} />

    </div>);

}

export default memo(SingleVoiceArtist);